import React from 'react';
import { useSupportPage } from './SupportPage.logic';
import SupportPageView from './SupportPage.view';

/**
 * Main container component for the Support/FAQ page
 * Connects the logic and view components
 * 
 * @returns {JSX.Element}
 */
const SupportPage = () => {
  const {
    activeCategory,
    setActiveCategory,
    searchQuery,
    filteredFaqs,
    handleSearchChange,
    sidebarItems
  } = useSupportPage();

  return (
    <SupportPageView
      activeCategory={activeCategory}
      setActiveCategory={setActiveCategory}
      searchQuery={searchQuery}
      filteredFaqs={filteredFaqs}
      handleSearchChange={handleSearchChange}
      sidebarItems={sidebarItems}
    />
  );
};

export default SupportPage; 